export const supportedLanguages = ['it', 'en'] as const
export type SupportedLanguage = (typeof supportedLanguages)[number]

type LocalizedRoute = Record<SupportedLanguage, string>

/** Canonical public routes. Italian is the approved source locale. */
export const localizedRoutes = {
  home: { it: '', en: '' },
  services: { it: 'servizi', en: 'services' },
  vehicles: { it: 'veicoli', en: 'vehicles' },
  vehicle: { it: 'veicoli/:slug', en: 'vehicles/:slug' },
  sellVehicle: { it: 'vendi-la-tua-auto', en: 'sell-your-car' },
  shortRental: { it: 'noleggio-breve', en: 'short-term-rental' },
  booking: { it: 'prenotazione', en: 'booking' },
  faq: { it: 'faq', en: 'faq' },
  contacts: { it: 'contatti', en: 'contacts' },
  privacy: { it: 'privacy', en: 'privacy' },
} as const satisfies Record<string, LocalizedRoute>

export type RouteKey = keyof typeof localizedRoutes

export function getLocalizedPath(route: RouteKey, language: SupportedLanguage, params: Record<string, string> = {}) {
  const segment = localizedRoutes[route][language]
  const resolved = segment.replace(/:([A-Za-z0-9_]+)/g, (_, key: string) => {
    if (!params[key]) throw new Error(`Missing route parameter: ${key}`)
    return encodeURIComponent(params[key])
  })
  return resolved ? `/${language}/${resolved}` : `/${language}`
}
